import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { NewEntryModel } from '../../models/new-entry.model';
import * as _ from 'lodash';


@Component({
  templateUrl: 'duplicates-dialog.component.html',
  styleUrls: ['duplicates-dialog.component.scss'],
})
export class DuplicatesDialogComponent {


  newEntry:NewEntryModel;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
  ) {
    this.newEntry = data.newEntry;
  }



  addDuplicateEntry() {
    this.newEntry.duplicates.push({
      breadcrumb: '',
      entryId: '000000000000000000000000'
    })
  }


  removeDuplicateEntry(dupToRemove) {
    _.remove(this.newEntry.duplicates, dup => dup === dupToRemove);
  }

}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/duplicates-dialog/duplicates-dialog.component.ts